import { z } from 'zod'
import { type Hex, type LowerHex, toLowerHex } from './hex'

export const bigintTextSchema = z.string().regex(/^\d+$/).transform(BigInt)

export const lowerHexSchema = z
  .string()
  .regex(/^0x[0-9a-f]*$/)
  .transform((v) => v as LowerHex)

export const txHashSchema = z
  .string()
  .regex(/^0x[0-9a-f]{64}$/)
  .transform((v) => v as LowerHex)

export const addressPrimitiveSchema = z
  .string()
  .regex(/^0x[0-9a-fA-F]{40}$/)
  .transform((v) => toLowerHex(v as Hex))
